<template>
  <div v-if="offerData1.length">
    <VueSlickCarousel v-bind="settings">
      <div
        id="carousel-home-middle"
        class="containers-image text-center"
        v-for="(image, index) in offerData1"
        :key="index"
      >
        <img class="image" :src="image.url.fileUrl" />
      </div>
    </VueSlickCarousel>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'middle-banner',
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        touchMove: true,
      },
    };
  },
  computed: {
    ...mapState({
      offerData1: ({ advertisement }) => advertisement.offer1,
    }),
  },
  methods: {
    ...mapActions({
      fetchhomeScreenOffer1Data2: 'advertisement/offerData1',
    }),
  },

  mounted() {
    this.fetchhomeScreenOffer1Data2();
  },
};
</script>

<style scoped>
.containers-image {
  display: block;
  width: 50%;
  place-items: center;
}

.image {
  width: 595px;
  border-radius: 10px;
}
</style>
